import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { SharedModule } from '@ddt-web/common';
import { DomModule } from '@ddt-web/dom';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { PdfPreviewerComponent } from './pdf-previewer/pdf-previewer.component';
import { StyleBoxComponent } from './report-component-helpers/style-box/style-box.component';
import { StyleBoxTooltipComponent } from './report-component-helpers/style-box/tooltip/style-box-tooltip.component';

@NgModule({
	declarations: [StyleBoxComponent, PdfPreviewerComponent, StyleBoxTooltipComponent],
	imports: [
		CommonModule,
		SharedModule,
		DzButtonModule,
		DomModule,
		GenericDirectivesModule
	],
	exports: [StyleBoxComponent, PdfPreviewerComponent]
})
export class PdfUtilsModule { }
